import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, Label, Input } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ArticulosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS || (process.env.REACT_APP_URL_AREAS || "").replace("areas", "empresas");
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;

  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [SKU, setSKU] = useState("");
  const [costoMX, setCostoMX] = useState(0);
  const [venta, setVenta] = useState(0);
  const [precioMayoreo, setPrecioMayoreo] = useState(0);

  const [largoProducto, setLargoProducto] = useState(0);
  const [anchoProducto, setAnchoProducto] = useState(0);
  const [altoProducto, setAltoProducto] = useState(0);
  const [pesoProducto, setPesoProducto] = useState(0);

  const [largoMaster, setLargoMaster] = useState(0);
  const [anchoMaster, setAnchoMaster] = useState(0);
  const [altoMaster, setAltoMaster] = useState(0);
  const [pesoMaster, setPesoMaster] = useState(0);

  const [lineas, setLineas] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setLineas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setEmpresas(res.data.filter((e) => e.is_active === "Si"));
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setProveedores(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    // El precio de venta capturado alimenta las 4 listas de precios que usa Ventas.
    const precio = parseFloat(venta) || 0;
    const mayoreo = parseFloat(precioMayoreo) || 0;
    try {
      await axios
        .post(
          URL_ARTICULOS,
          {
            codigo,
            nombre,
            SKU: SKU.toUpperCase(),
            lineas: selectedLinea,
            empresas: selectedEmpresa,
            proveedores: selectedProveedor,
            costoMX: parseFloat(costoMX) || 0,
            venta: precio,
            precioMayoreo: mayoreo,
            // Lista 1 = precio normal, Lista 2 = mayoreo (Ventas cotiza por lista de cliente)
            lista1: precio,
            lista2: mayoreo,
            lista3: precio,
            lista4: precio,
            lista1Bruto: precio,
            lista2Bruto: mayoreo,
            lista3Bruto: precio,
            lista4Bruto: precio,
            largoProducto: parseFloat(largoProducto) || 0,
            anchoProducto: parseFloat(anchoProducto) || 0,
            altoProducto: parseFloat(altoProducto) || 0,
            pesoProducto: parseFloat(pesoProducto) || 0,
            largoMaster: parseFloat(largoMaster) || 0,
            anchoMaster: parseFloat(anchoMaster) || 0,
            altoMaster: parseFloat(altoMaster) || 0,
            pesoMaster: parseFloat(pesoMaster) || 0,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )

        .then((data) => {
          axios
            .post(
              URL_INVENTARIOS,
              {
                articulos: data.data._id,
                areas: AREAS_CEDIS,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )

            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Crear Modelo",
                  detalle: `${nombre} ${codigo}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container">
          <h3 align="center">Nuevo Articulo</h3>
          <Form onSubmit={saveArticulos}>
            <Row>
              <Col md={12}>
                <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  DATOS GENERALES
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Modelo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>SKU</Label>
                <Input
                  type="text"
                  placeholder="SKU"
                  value={SKU}
                  required
                  onChange={(e) => {
                    setSKU(e.target.value.toUpperCase());
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  CLASIFICACIÓN
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Linea</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedLinea}
                  required
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                  }}
                >
                  <option value="">Selecciona una Linea</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Empresa</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="">Selecciona una Empresa</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.codigo} - {a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  COSTO Y PRECIO
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Costo MX</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Costo MX"
                  value={costoMX}
                  required
                  onChange={(e) => {
                    setCostoMX(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Precio</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Precio"
                  value={venta}
                  required
                  onChange={(e) => {
                    setVenta(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Precio Mayoreo</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Precio Mayoreo"
                  value={precioMayoreo}
                  onChange={(e) => {
                    setPrecioMayoreo(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  MEDIDAS PRODUCTO
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Largo</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Largo"
                  value={largoProducto}
                  onChange={(e) => {
                    setLargoProducto(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Ancho</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Ancho"
                  value={anchoProducto}
                  onChange={(e) => {
                    setAnchoProducto(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Alto</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Alto"
                  value={altoProducto}
                  onChange={(e) => {
                    setAltoProducto(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Peso</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Peso"
                  value={pesoProducto}
                  onChange={(e) => {
                    setPesoProducto(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  MEDIDAS CAJA
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Largo</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Largo"
                  value={largoMaster}
                  onChange={(e) => {
                    setLargoMaster(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Ancho</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Ancho"
                  value={anchoMaster}
                  onChange={(e) => {
                    setAnchoMaster(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Alto</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Alto"
                  value={altoMaster}
                  onChange={(e) => {
                    setAltoMaster(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Peso</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Peso"
                  value={pesoMaster}
                  onChange={(e) => {
                    setPesoMaster(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoArticulos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosCreate;
